import {
    formatNumber, getPlatFormReactionsData, metricObjectGetter, platformReactionCountGetter, simpleGetterFactory,
    simpleSetterFactory
} from "@/dashboards/widgets/fantasticchart/FantasticUtilities";

export default {
    "totalPlatformImpressions": {
        tooltipArticle: "a total",
        name: "Platform impressions",
        chartName: "Platform impressions",
        yLabel: {long: "Total Platform Impressions", short: "# Platform Impressions"},
        defaultSortOptions: {
            label: "Platform impressions",
            field: "totalPlatformImpressions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: simpleGetterFactory("totalPlatformImpressions"),
        setter: simpleSetterFactory("totalPlatformImpressions")
    },
    "totalPlatformEngagement": {
        tooltipArticle: "a total",
        name: "Platform engagement",
        chartName: "Platform engagement",
        yLabel: {long: "Total Platform Engagement", short: "# Platform Engagement"},
        defaultSortOptions: {
            label: "Platform Engagement",
            field: "totalPlatformEngagement",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: simpleGetterFactory("totalPlatformEngagement"),
        setter: simpleSetterFactory("totalPlatformEngagement")
    },
    "totalPlatformReactions": {
        tooltipArticle: "a total",
        name: "Platform reactions",
        chartName: "Platform reactions",
        yLabel: {long: "Total Platform Reactions", short: "# Platform Reactions"},
        defaultSortOptions: {
            label: "Platform reactions",
            field: "totalPlatformReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: simpleGetterFactory("totalPlatformReactions"),
        setter: simpleSetterFactory("totalPlatformReactions")
    },
    "countByFacebookReactions": {
        tooltipArticle: "a total",
        name: "Facebook reactions",
        chartName: "Facebook reactions",
        yLabel: {long: "Facebook reactions", short: "# Facebook reactions"},
        defaultSortOptions: {
            label: "Facebook reactions",
            field: "countByFacebookReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: platformReactionCountGetter,
        setter: simpleSetterFactory("countByFacebookReactions"),
        autoCompare: 'engagementType',
        isMultiple: true,

        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "countByInstagramReactions": {
        tooltipArticle: "a total",
        name: "Instagram reactions",
        chartName: "Instagram reactions",
        yLabel: {long: "Instagram reactions", short: "# Instagram reactions"},
        defaultSortOptions: {
            label: "Instagram reactions",
            field: "countByInstagramReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: platformReactionCountGetter,
        setter: simpleSetterFactory("countByInstagramReactions"),
        autoCompare: 'engagementType',
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "countByLinkedInReactions": {
        tooltipArticle: "a total",
        name: "LinkedIn reactions",
        chartName: "LinkedIn reactions",
        yLabel: {long: "LinkedIn reactions", short: "# LinkedIn reactions"},
        defaultSortOptions: {
            label: "LinkedIn reactions",
            field: "countByLinkedInReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: platformReactionCountGetter,
        setter: simpleSetterFactory("countByLinkedInReactions"),
        autoCompare: 'engagementType',
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "countByTwitterReactions": {
        tooltipArticle: "a total",
        name: "Twitter reactions",
        chartName: "Twitter reactions",
        yLabel: {long: "Twitter reactions", short: "# Twitter reactions"},
        defaultSortOptions: {
            label: "Twitter reactions",
            field: "countByTwitterReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: platformReactionCountGetter,
        setter: simpleSetterFactory("countByTwitterReactions"),
        autoCompare: 'engagementType',
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "countByTikTokReactions": {
        tooltipArticle: "a total",
        name: "TikTok reactions",
        chartName: "TikTok reactions",
        yLabel: {long: "TikTok reactions", short: "# TikTok reactions"},
        defaultSortOptions: {
            label: "Twitter reactions",
            field: "countByTikTokReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: platformReactionCountGetter,
        setter: simpleSetterFactory("countByTikTokReactions"),
        autoCompare: 'engagementType',
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "volumeByFacebookReactions": {
        tooltipArticle: "a total",
        name: "Facebook Engagement Types",
        chartName: "Facebook Engagement Types",
        yLabel: {long: "Facebook Engagement Types", short: "# Facebook Engagement Types"},
        defaultSortOptions: {
            label: "Facebook Engagement Types",
            field: "volumeByFacebookReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: metricObjectGetter,
        setter: simpleSetterFactory("volumeByFacebookReactions"),
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "volumeByInstagramReactions": {
        tooltipArticle: "a total",
        name: "Instagram Engagement Types",
        chartName: "Instagram Engagement Types",
        yLabel: {long: "Instagram Engagement Types", short: "# Instagram Engagement Types"},
        defaultSortOptions: {
            label: "Instagram Engagement Types",
            field: "volumeByInstagramReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: metricObjectGetter,
        setter: simpleSetterFactory("volumeByInstagramReactions"),
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "volumeByLinkedInReactions": {
        tooltipArticle: "a total",
        name: "Linkedin Engagement Types",
        chartName: "Linkedin Engagement Types",
        yLabel: {long: "Linkedin Engagement Types", short: "# Linkedin Engagement Types"},
        defaultSortOptions: {
            label: "Linkedin Engagement Types",
            field: "volumeByLinkedInReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: metricObjectGetter,
        setter: simpleSetterFactory("volumeByLinkedInReactions"),
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "volumeByTwitterReactions": {
        tooltipArticle: "a total",
        name: "Twitter Engagement Types",
        chartName: "Twitter Engagement Types",
        yLabel: {long: "Twitter Engagement Types", short: "# Twitter Engagement Types"},
        defaultSortOptions: {
            label: "Twitter Engagement Types",
            field: "volumeByTwitterInReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: metricObjectGetter,
        setter: simpleSetterFactory("volumeByTwitterReactions"),
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },
    "volumeByTikTokReactions": {
        tooltipArticle: "a total",
        name: "TikTok Engagement Types",
        chartName: "TikTok Engagement Types",
        yLabel: {long: "TikTok Engagement Types", short: "# TikTok Engagement Types"},
        defaultSortOptions: {
            label: "TikTok Engagement Types",
            field: "volumeByTikTokReactions",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: metricObjectGetter,
        setter: simpleSetterFactory("volumeByTikTokInReactions"),
        isMultiple: true,
        getData: (model, query, groupBy, ignore, ignoreY, getData) => {
            return getPlatFormReactionsData(model, query, groupBy, ignore, ignoreY, getData)
        }
    },

    "totalPlatformReshares": {
        tooltipArticle: "a total",
        name: "Platform reshares",
        chartName: "Platform reshares",
        yLabel: {long: "Total Platform Reshares", short: "# Platform Reshares"},
        defaultSortOptions: {
            label: "Platform reshares",
            field: "totalPlatformReshares",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: simpleGetterFactory("totalPlatformReshares"),
        setter: simpleSetterFactory("totalPlatformReshares")
    },
    "totalPlatformComments": {
        tooltipArticle: "a total",
        name: "Platform comments",
        chartName: "Platform comments",
        yLabel: {long: "Total Platform Comments", short: "# Platform Comments"},
        defaultSortOptions: {
            label: "Platform comments",
            field: "totalPlatformComments",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: simpleGetterFactory("totalPlatformComments"),
        setter: simpleSetterFactory("totalPlatformComments")
    },
    "totalPlatformVideoViews": {
        tooltipArticle: "a total",
        name: "Platform video views",
        chartName: "Platform video views",
        yLabel: {long: "Total Platform Video Views", short: "# Platform Video Views"},
        defaultSortOptions: {
            label: "Platform video views",
            field: "totalPlatformVideoViews",
            order: "descending"
        },
        formatY: formatNumber,
        formatLabel: formatNumber,
        getter: simpleGetterFactory("totalPlatformVideoViews"),
        setter: simpleSetterFactory("totalPlatformVideoViews")
    }
}